export class ChargeTransactions {
  chargeDate: Date;


  chargeTypeName: string;
  amount: number;
  description: string;

  tenantName: string;
  so: string;
  invoiceNo: string;
  chargeSource: string;
  requestNo: string;
  requestId: number;
  chargesStatus: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/charge-transactions.ts